import * as Yup from "yup";

const NATIONALITY = {
  DOMESTIC: "domestic",
  FOREIGNER: "foreigner",
};

export const initialValues = {
  email: null,
  telephoneNumber: null,
  personalEmail: null,
  mobileNumber: null,
  registerAddress: null,
  registerProvinceId: null,
  registerDistrictId: null,
  registerSubDistrictId: null,
  registerZipCode: null,
  registerAddressEn: NATIONALITY.DOMESTIC,
  registerProvinceId: null,
  registerDistrictId: null,
  registerSubDistrictId: null,
  registerZipCode: null,
  address: null,
  provinceId: null,
  districtId: null,
  subDistrictId: null,
  zipCode: null,
  addressEn: NATIONALITY.DOMESTIC,
  provinceId: null,
  districtId: null,
  subDistrictId: null,
  zipCode: null,
  // maritalStatusId: null,
  // militaryStatusId: null,
  // bloodGroupId: null,
  // weight: null,
  // height: null,
  // remark: null,
};

const EmployeeInfoContactSchema = Yup.object().shape({
  registerAddress: Yup.string().required("Please enter address."),
  registerProvinceId: Yup.string().required("Please select province."),
  registerDistrictId: Yup.string().required("Please select district."),
  registerSubDistrictId: Yup.string().required("Please select sub district."),
  registerZipCode: Yup.string().required("Please select zip code."),
  registerAddressEn: Yup.string().required("Please enter address."),
  registerProvinceId: Yup.string().required("Please select province."),
  registerDistrictId: Yup.string().required("Please select district."),
  registerSubDistrictId: Yup.string().required("Please select sub district."),
  registerZipCode: Yup.string().required("Please select zip code."),

});

export default EmployeeInfoContactSchema;
